export class  DayHours {
    value: string;
    viewValue: string;

}

export class SearchDates {
    searchStartDate: Date;
    searchEndDate: Date;
}